import useFetch from '../hooks/useFetch'
import { apiWrapper } from './dataHookUtils'

// Cached per userId for the lifetime of the page load: the router re-runs the verify loader on
// every navigation and this lookup queries Salesforce. Login and logout both do a full reload, so a
// cached profile cannot outlive its session. The promise is cached (not the result) so concurrent
// loader runs share a single request; a failed lookup is dropped so the next navigation retries.
const profileCache = {}

export default () => {
  const fetch = useFetch()

  // { name, email, territory } of the logged-in user, from this portal's API (accounts/me)
  const fetchProfile = async (userId) => {
    if (!userId) return {}
    if (!profileCache[userId]) {
      profileCache[userId] = apiWrapper({ fetch, url: 'accounts/me', options: { method: 'GET' } })
        .catch((e) => {
          delete profileCache[userId]
          console.log(e)
          return {}
        })
    }
    return await profileCache[userId]
  }

  return {
    fetchProfile
  }
}
